module.exports = __webpack_public_path__ + "static/img/questionnaire1.3173c55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/questionnaire1.png
// module id = ghh7
// module chunks = 1